import React, { useEffect, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { FileUploadIcon } from "../Icons";
import apiClient from "../apiClient";
import { debounce } from "../utils/general";
import { useModalContext } from "./context/ModalProvider";
import BtnLoad from "../components/BtnLoad";
import { useSelector } from "react-redux";
import { CREATE_GROUP_CSV, CREATE_USER_CSV } from "../apiClient/apiEndpoints";

const { useUnoSelector } = UnoStoreHooks;
const { Table, DropdownSearch, SimToggleSwitch } = UiComponents;

const roleTypeKey = {
  "group": "typeId",
  "user": "role"
}

const CSVModalTable = () => {
  const configData = useUnoSelector((state) => state.config);
  const configSlice = useSelector((state) => state.configSlice);
  const { modalState, closeModal, handleLoading } = useModalContext();
  const { csvList, params, handleRefreshTab, type, status, loading } = modalState;
  const UUID = params?.uuid;
  const [roleOptions, setRoleOptions] = useState({
    "group": [],
    "user": []
  })
  const [allRoleId, setAllRoleTypeId] = useState(null);
  const [allUserRoleId, setAllUserRoleTypeId] = useState(null);
  const [entriesDetails, setEntriesDetails] = useState({
    total: null,
    new: null,
    error: null,
  });
  const [preview, setPreview] = useState(true);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(csvList);
  }, [modalState, csvList])

  const handleUpdateRoleType = (data, index, key) => {
    let updatedList = list.map((item, i) => index === i ? { ...item, [key]: data } : item);
    setList(updatedList);
  }

  useEffect(() => {
    let groupTypesList = configSlice.groupTypes.map((role) => ({ value: role.id, label: role.name }));
    let userTypesList = configSlice.roles.map((role) => ({ value: role.id, label: role.name }));
    setRoleOptions({
      "group": groupTypesList,
      "user": userTypesList
    })
  }, [configSlice]);


  useEffect(() => {
    setPreview(true);
    if (status && type === "group") {
      setTableHeaders([
        { title: "S.N.", className: "header-name" },
        { title: "Avatar", className: "header-name" },
        { title: "Name", className: "header-name" },
        { title: "Identifier", className: "header-name" },
        { title: "Type", className: "header-name" },
        { title: "Unristricted", className: "header-name" },

        { title: "User Name", className: "header-name" },
        { title: "User Email", className: "header-name" },
        { title: "User Avatar", className: "header-name" },
        { title: "User Designation", className: "header-name" },
        { title: "User Phone", className: "header-name" },
        { title: "User UID", className: "header-name" },
        { title: "User Password", className: "header-name" },
        { title: "User Type", className: "header-name" },

      ]);

      let _list = list.map((item, i) => {
        return {
          cellData: [
            { value: i + 1, className: "cell-name" },
            {
              value: item.avatar ? <img src={item.avatar || null} alt={item.name} style={{ width: "40px" }} /> : "",
              className: "cell-name",
            },
            { value: item.name, className: "cell-name" },
            { value: item.identifier, className: "cell-name" },
            {
              value: <DropdownSearch
                // label="Group Type *"
                error={item.error}
                selectProps={{
                  options: roleOptions[type],
                  value: item.typeId,
                  onChange: (e) => handleUpdateRoleType(e, i, roleTypeKey[type]),
                }}
              />,
              className: "cell-name"
            },
            {
              value: <SimToggleSwitch
                checked={item.handDown}
                onChange={(e) => handleUpdateRoleType(!item.handDown, i, "handDown")}
              />,
              className: "cell-name"
            },



            { value: item.userName, className: "cell-name" },
            { value: item.userEmail, className: "cell-name" },
            {
              value: item.userAvatar ? <img src={item.userAvatar || null} alt={item.name} style={{ width: "40px" }} /> : "",
              className: "cell-name",
            },
            { value: item.userDesignation, className: "cell-name" },
            { value: item.userPhone, className: "cell-name" },
            { value: item.userUID, className: "cell-name" },
            { value: item.userPassword, className: "cell-name" },
            item.userName ?
              {
                value: <DropdownSearch
                  // label="Group Type *"
                  error={item.userError}
                  selectProps={{
                    options: roleOptions["user"],
                    value: item.role,
                    onChange: (e) => handleUpdateRoleType(e, i, "role"),
                  }}
                />,
                className: "cell-name"
              } : null,

          ],
        };
      });

      setTableRows(_list);

    } else if (status && type === "user") {
      setTableHeaders([
        { title: "S.N.", className: "header-name" },
        { title: "Avatar", className: "header-name" },
        { title: "Name", className: "header-name" },
        { title: "Email", className: "header-email" },
        { title: "UID", className: "header-name" },
        { title: "phone", className: "header-name" },
        { title: "Password", className: "header-name" },
        { title: "Designation", className: "header-name" },
        { title: "Role", className: "header-email" },
      ]);

      let _list = list.map((item, i) => {
        return {
          cellData: [
            { value: i + 1, className: "cell-name" },
            {
              value: item.avatar ? <img src={item.avatar || null} alt={item.name} style={{ width: "40px" }} referrerPolicy="no-referrer" /> : "",
              className: "cell-name",
            },
            { value: item.name, className: "cell-name" },
            { value: item.email, className: "cell-name" },
            { value: item.uid, className: "cell-name" },
            { value: item.phone, className: "cell-name" },
            { value: item.password, className: "cell-name" },
            { value: item.designation, className: "cell-name" },
            {
              value: <DropdownSearch
                // label="Group Type *"
                error={item.error}
                selectProps={{
                  options: roleOptions[type],
                  value: item.role,
                  onChange: (e) => handleUpdateRoleType(e, i, roleTypeKey[type]),
                }}
              />,
              className: "cell-name"
            }
          ],
        };
      });

      setTableRows(_list);
    }
  }, [list, roleOptions]);

  const handleCloseModal = () => {
    closeModal();
    setTimeout(() => {
      setEntriesDetails({
        total: null,
        new: null,
        error: null,
      });
      setPreview(true);
      setTableHeaders([]);
      setTableRows([]);
    }, 2500);
  }

  const handleSelectAllDefaultRole = (e) => {
    let updatedList = list.map((pre) => ({ ...pre, [roleTypeKey[type]]: e }));
    setList(updatedList);
    setAllRoleTypeId(e);
  }

  const handleSelectAllDefaultUserRole = (e) => {
    let updatedList = list.map((pre) => ({ ...pre, "role": e }));
    setList(updatedList);
    setAllUserRoleTypeId(e);
  }

  const handleCSVCreateGroup = async (e) => {
    if (loading) return;

    const errorList = list.map(e => ({
      ...e,
      error: e.typeId ? null : "select type",
      userError: e.role ? null : "select User type"
    }));

    const hasNullRole = errorList.some(e => e.error || e.userError);

    if (hasNullRole) {
      setList(errorList);
      return;
    }

    try {
      handleLoading(true);
      const bodyData = {
        data: list.map(item => ({ ...item, typeId: item?.typeId?.value || null, role: item?.role?.value || null })),
      };
      const response = await apiClient.post(`${configData.config.UNO_URL}${CREATE_GROUP_CSV}/${UUID}`, bodyData);
      if (handleRefreshTab) handleRefreshTab();
      if (response.errorCount > 0) {
        setEntriesDetails({
          total: response.successCount + response.errorCount,
          new: response.successCount,
          error: response.errorCount,
        });
        setTableHeaders([
          { title: "S.N.", className: "header-name" },
          { title: "Name", className: "header-name" },
          { title: "Identifier", className: "header-name" },
          { title: "Reason", className: "header-email" },
        ]);
        let _list = response.errors.map((error, i) => {
          return {
            cellData: [
              { value: i + 1, className: "cell-name" },
              { value: error.name, className: "cell-name" },
              { value: error.identifier, className: "cell-name" },
              { value: error.reason, className: "cell-age" },
            ],
          };
        });
        setTableRows(_list);
        setPreview(false);
      }else{
        handleCloseModal();
      }
    } catch (error) {
      console.error(error);
    } finally {
      handleLoading(false);
    }
  };

  const handleCSVCreateUser = async () => {
    if (loading) return;
    const errorList = list.map(e => ({
      ...e,
      error: e.role ? null : "select role"
    }));

    const hasNullRole = errorList.some(e => e.error);

    if (hasNullRole) {
      setList(errorList);
      return;
    }

    try {
      handleLoading(true);
      const bodyData = {
        data: list.map(item => ({ ...item, role: item?.role?.value || null }))
      };
      const response = await apiClient.post(`${configData.config.UNO_URL}${CREATE_USER_CSV}/${UUID}`, bodyData);
      if (handleRefreshTab) handleRefreshTab();
      if (response.errorCount > 0) {
        setEntriesDetails({
          total: response.successCount + response.errorCount,
          new: response.successCount,
          error: response.errorCount,
        });

        setTableHeaders([
          { title: "S.N.", className: "header-name" },
          { title: "Name", className: "header-name" },
          { title: "Email", className: "header-email" },
          { title: "UID", className: "header-name" },
          { title: "Reason", className: "header-email" },
        ]);

        let _list = response.errors.map((error, i) => {
          return {
            cellData: [
              { value: i + 1, className: "cell-name" },
              { value: error.name, className: "cell-name" },
              { value: error.email, className: "cell-age" },
              { value: error.uid, className: "cell-name" },
              { value: error.reason, className: "cell-age" },
            ],
          };
        });
        setTableRows(_list);
        setPreview(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      handleLoading(false);
    }
  };

  let debounceHandleCreateGroups = debounce(handleCSVCreateGroup, 500);
  let debounceHandleCreateUsers = debounce(handleCSVCreateUser, 500);

  return (
    <>
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center ">
          <div className="csvuploadheader d-flex align-items-center gap-2">
            <div className="filterbtn">
              <div className="btninadjust">
                <FileUploadIcon />
              </div>
            </div>
            <div>
              <h6 className="m-0">Upload CSV</h6>
            </div>
            <div>
            </div>

          </div>
          {!preview ? (
            <div>
              <button className="tableinfo">
                Total Entries <span> {entriesDetails.total} </span>
              </button>
              <button className="tableinfo">
                Add new Entries <span> {entriesDetails.new} </span>
              </button>
              <button className="tableinfo">
                Not Added <span> {entriesDetails.error} </span>
              </button>
            </div>
          )
            :
            <>
              <div className="d-flex drop-search " style={{ position: "relative", bottom: "0.75rem", fontSize: "0.9rem" }}>
                <DropdownSearch
                  label="Role type for all group*"
                  error={null}
                  selectProps={{
                    options: roleOptions[type],
                    value: allRoleId,
                    onChange: (e) => handleSelectAllDefaultRole(e),
                  }}
                />
              </div>
              <div className="d-flex drop-search " style={{ position: "relative", bottom: "0.75rem", fontSize: "0.9rem" }}>
                <DropdownSearch
                  label="Role type for all user*"
                  error={null}
                  selectProps={{
                    options: roleOptions["user"],
                    value: allUserRoleId,
                    onChange: (e) => handleSelectAllDefaultUserRole(e),
                  }}
                />
              </div>
            </>
          }
        </div>

        <Table tableHeaders={tableHeaders} tableRows={tableRows} />

        <div className="modal-footer justify-content-end p-0">
          <div className="modal-footer-btns">
            <button onClick={handleCloseModal} className="cancel">
              Cancel
            </button>
            {preview && (
              <>
                {type === "group" ? (
                  <button className="save" onClick={() => debounceHandleCreateGroups()}>
                    {loading ? <BtnLoad /> : "Save"}{" "}
                  </button>
                ) : (
                  <button className="save" onClick={() => debounceHandleCreateUsers()}>
                    {loading ? <BtnLoad /> : "Save"}{" "}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CSVModalTable;
